module.exports = __webpack_public_path__ + "static/homepage-desktop-first-image-c8fa89e58d6d1f98693b07fb94534ec7.png";